import GenericTextValue from "./GenericTextValue";
import GenericIdValue from "./GenericIdValue";
// import TypeId from "./TypeId";
import AmountSizeUnit from "./AmountSizeUnit";
import GenericIdValueList from "./GenericIdValueList";
import {keys} from "../config/nameSpacesKeys";
import {assetKeys} from "../config/constants";
export default class Distribution {
  constructor(name, initialValue, namespace, // downloadURLNameSpace, accessURLNameSpace,  mediaTypeNameSpace,
      byteSizeNameSpace, packageFormatNameSpace, formatNameSpace, sizeNameSpace) {
    this.namespace = namespace;
    this.name = name;
    // this.downloadURLNameSpace = downloadURLNameSpace;
    // this.accessURLNameSpace = accessURLNameSpace;
    // this.mediaTypeNameSpace = mediaTypeNameSpace;
    this.byteSizeNameSpace = byteSizeNameSpace;
    this.packageFormatNameSpace = packageFormatNameSpace;
    this.formatNameSpace = formatNameSpace;
    this.sizeNameSpace = sizeNameSpace;
    // this.downloadURL = new GenericIdValue("downloadURL", null, downloadURLNameSpace);
    // this.accessURL = new GenericIdValue("accessURL", null, accessURLNameSpace);
    // this.mediaType = new GenericIdValue("mediaType", null, mediaTypeNameSpace);
    this.byteSize = new GenericTextValue("byteSize", null, byteSizeNameSpace);
    this.packageFormat = new GenericIdValue("packageFormat", null, packageFormatNameSpace);
    // this.packageFormat = new TypeId((name = "packageFormat"), null, packageFormatNameSpace, keys.purlMediaType);
    this.format = new GenericIdValueList("format", null, formatNameSpace);
    this.size = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.createEmptyAmountSizeUnitObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  /* getDownloadURLObj() {
    return this.downloadUrl;
  }
  setDownLoadURLObj(downloadURLObj) {
    this.downloadURL = downloadURLObj;
  }
  getAccessURLObj() {
    return this.accessURL;
  }
  setAccessURLObj(accessURLObj) {
    this.accessURL = accessURLObj;
  }
  getMediaTypeObj() {
    return this.mediaType;
  }
  setMediaTypeObj(mediaTypeObj) {
    this.mediaType = mediaTypeObj;
  }
  */

  getByteSizeObj() {
    return this.byteSize;
  }
  getPackageFormatObj() {
    return this.packageFormat;
  }

  setPackageFormatObj(packageFormatObj) {
    this.packageFormat = packageFormatObj;
  }

  getFormatObj() {
    return this.format;
  }

  setFormatObj(formatObj) {
    this.format = formatObj;
  }

  createEmptyAmountSizeUnitObj() {
    const amountSizeUnit = new AmountSizeUnit("size", null, this.sizeNameSpace, keys.amount, keys.sizeUnit);
    this.size.push(amountSizeUnit);
  }

  createAmountSizeUnitObj(obj) {
    const amountSizeUnit = new AmountSizeUnit("size", null, this.sizeNameSpace, keys.amount, keys.sizeUnit);
    amountSizeUnit.parseInputJSON(obj);
    this.size.push(amountSizeUnit);
  }

  removeAmountSizeUnitObj(obj, index) {
    if (index < 0 || index >= this.size.length) {
      return false;
    }
    this.size.splice(index, 1);
  }

  setSize(inputObj) {
    // console.log(inputObj, this.sizeNameSpace);
    const sizeObj = inputObj[this.sizeNameSpace];
    if (Array.isArray(sizeObj)) {
      for (const entry of Object.entries(sizeObj)) {
        const value = entry[1];
        this.createAmountSizeUnitObj(value);
      }
    } else {
      this.createAmountSizeUnitObj(sizeObj);
    }
  }

  setValueObj(obj) {
    // console.log(obj);
    // this.downloadURL.parseInputJSON(obj);
    // this.accessURL.parseInputJSON(obj);
    // this.mediaType.parseInputJSON(obj);
    this.byteSize.parseInputJSON(obj);
    this.packageFormat.parseInputJSON(obj);
    this.format.parseInputJSON(obj);
    this.setSize(obj);
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON[this.namespace];
    // console.log(inputJSON, this.namespace);
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.setValueObj(value);
      }
    } else {
      this.setValueObj(obj);
    }
  }

  getExpandedFormatValue() {
    const obj = {};
    // const accesUrlExpanded = this.accessURL.getExpandedFormatValue();
    // const downloadUrlExpanded = this.downloadURL.getExpandedFormatValue();
    // const mediaTypeExpanded = this.mediaType.getExpandedFormatValue();
    const byteSizeExpanded = this.byteSize.getExpandedFormatValue(true);
    const packageFormatExpanded = this.packageFormat.getExpandedFormatValue();
    const formatExpanded = this.format.getExpandedFormatValue();
    const sizeExpanded = [];
    for (let index = 0; index < this.size.length; index++) {
      const sizeItem = this.size[index];
      sizeExpanded.push(sizeItem.getExpandedFormatValue());
    }
    obj[assetKeys.type] = [`${keys.distributionType}`];
    // obj[this.accessURL.getNameSpace()] = accesUrlExpanded;
    // obj[this.downloadURL.getNameSpace()] = downloadUrlExpanded;
    // obj[this.mediaType.getNameSpace()] = mediaTypeExpanded;
    obj[this.byteSize.getNameSpace()] = byteSizeExpanded;
    obj[this.packageFormat.getNameSpace()] = packageFormatExpanded;
    obj[this.format.getNameSpace()] = formatExpanded;
    obj[this.sizeNameSpace] = sizeExpanded;
    return obj;
  }

  isEmpty() {
    const condition1 = this.byteSize.isEmpty() && this.packageFormat.isEmpty() && this.format.isEmpty(); // && this.mediaType.isEmpty()  this.accessURL.isEmpty() && this.downloadURL.isEmpty()
    let condition2 = true;
    for (let index = 0; index < this.size.length; index++) {
      const sizeItem = this.size[index];
      condition2 = condition2 && sizeItem.isEmpty();
    }
    return condition1 && condition2;
  }
}
